import { ParamConfig } from "../../../utils/params/ParamsConfig";
import { NodeContext } from "../../../../poly/NodeContext";
import { ColorConversion } from "../../../../../core/Color";
import { Color } from "three";
import { TypeAssert } from "../../../../poly/Assert";
export var BackgroundMode = /* @__PURE__ */ ((BackgroundMode2) => {
  BackgroundMode2["NONE"] = "none";
  BackgroundMode2["COLOR"] = "color";
  BackgroundMode2["TEXTURE"] = "texture";
  return BackgroundMode2;
})(BackgroundMode || {});
export const BACKGROUND_MODES = ["none" /* NONE */, "color" /* COLOR */, "texture" /* TEXTURE */];
const CallbackOptions = {
  callback: (node) => {
    SceneBackgroundController.update(node);
  }
};
export function SceneBackgroundParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.backgroundMode = ParamConfig.INTEGER(BACKGROUND_MODES.indexOf("color" /* COLOR */), {
        menu: {
          entries: BACKGROUND_MODES.map((mode, i) => {
            return { name: mode, value: i };
          })
        },
        ...CallbackOptions,
        separatorBefore: true
      });
      this.bgColor = ParamConfig.COLOR([0.4, 0.4, 0.4], {
        visibleIf: { backgroundMode: BACKGROUND_MODES.indexOf("color" /* COLOR */) },
        ...CallbackOptions,
        conversion: ColorConversion.SRGB_TO_LINEAR
      });
      this.bgTexture = ParamConfig.NODE_PATH("", {
        visibleIf: { backgroundMode: BACKGROUND_MODES.indexOf("texture" /* TEXTURE */) },
        nodeSelection: {
          context: NodeContext.COP
        },
        dependentOnFoundNode: false,
        ...CallbackOptions
      });
    }
  };
}
export class SceneBackgroundController {
  constructor(node) {
    this.node = node;
  }
  setMode(mode) {
    this.node.p.backgroundMode.set(BACKGROUND_MODES.indexOf(mode));
  }
  backgroundMode() {
    return BACKGROUND_MODES[this.node.pv.backgroundMode];
  }
  async update() {
    const backgroundMode = this.backgroundMode();
    switch (backgroundMode) {
      case "none" /* NONE */: {
        return this._setBackgroundNone();
      }
      case "color" /* COLOR */: {
        return await this._setBackgroundColor();
      }
      case "texture" /* TEXTURE */: {
        return await this._setBackgroundTexture();
      }
    }
    TypeAssert.unreachable(backgroundMode);
  }
  _setBackgroundNone() {
    const scene = this.node.object;
    scene.background = null;
  }
  async _setBackgroundColor() {
    const scene = this.node.object;
    const pv = this.node.pv;
    await this.node.p.bgColor.compute();
    if (scene.background && scene.background instanceof Color) {
      scene.background.copy(pv.bgColor);
    } else {
      scene.background = pv.bgColor;
    }
  }
  async _setBackgroundTexture() {
    const scene = this.node.object;
    const pv = this.node.pv;
    const node = pv.bgTexture.nodeWithContext(NodeContext.COP);
    if (node) {
      const container = await node.compute();
      scene.background = container.texture();
    } else {
      this.node.states.error.set("bgTexture node not found");
    }
  }
  static update(node) {
    node.sceneBackgroundController.update();
  }
}
